import React, { FC, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Dropdown,
  FlexBox,
  Fonts,
  HintTooltip,
  Tooltip,
  useBreakpoint,
  useIsMobile,
  useToasts
} from "@brg/ui";
import { useTranslation } from 'react-i18next';
import { ProjectTooltip } from "../../../components/tooltips";
import { ProjectDelegate } from "../../../../project-delegate";
import { API, Endpoints, Project, ProjectAPI, Team } from "@brg/api";
import { CreateLinkTo } from "../../../constants/linkTo";
import { bProfile, useProfile, ProfileUtils, ProfileRole } from "@brg/auth";
import BookmarkButton from "../../../components/bookmarkButton/bookmarkButton";
import ViewCount from "../../../components/viewCount/ViewCount";
import { LikesController } from "../../../../core/modules/likes.module";
import { ProjectOnDisplay } from '../../../helpers/projectStatus';
import { IconWrapper, IconWrapperSpecial2 } from "../../../assets/styles";
import styled, { useTheme, css } from "styled-components";
import { useHistory, useRouteMatch } from "react-router-dom";
import { LayoutConst, useModal } from "core";
import { displayProjectEditError } from "../../../components/tooltips/ProjectTooltip";
import { AppTester } from '../../../../supporting';
import { useDispatch, useSelector } from "react-redux";
import { useVsCompetition } from "shared/hooks/useVsCompetition";
import { downloadPDF } from "../../../components/PrintProject/model/downloadPDF";
import { SP_VOTE_COLLECTION_SIGN } from "../../VotesAdmin/constants";
import { MoreIcon } from "../../../icons/projectToolsWithResize/MoreIcon";
import { ShareIcon } from "../../../icons/projectToolsWithResize/ShareIcon";
import { ProjectRatingsButton } from "./ProjectRatingsButton";
import { checkIsLongreadAndTeamOwner } from "../../../helpers/designer/checkIsLongreadAndTeamOwner";
import { CurrentProjectActions } from "../../../reducers/CurrentProject";
import { getTooltipStyles, tooptipStylesWhite } from "shared/constants/tooptipStyles";
import {BookDelegate} from "../../../../_deziiign/books/core/book-delegate";
import { protectProcessStatuses, protectStatuses } from "shared/helpers/protectStatus";
import {selectorLMSModuleInfo} from "../../../reducers/LMSSlice";
import { HsePolicies } from "shared/constants/HsePolicies";
import { isExpert, isExpertByPolicy } from "shared/helpers/utils/TagsUtils";
import ProfileFoldersSlice, { ProfileFoldersSelector } from "shared/reducers/ProfileFoldersSlice";
import { useFoldersController } from "shared/hooks/useFoldersController";
import urlApi from "shared/actions/urlApi";
import { AddProductIcon } from "shared/icons/projectToolsWithResize/AddProductIcon";
import { createProductByProject } from "shared/helpers/CreateProductByProject";
import RepostButton from "shared/components/repostButton/repostButton";
import { LMSGradeIcon } from "shared/icons/projectToolsWithResize/LMSGradeIcon";
import { LMSCourseTypes } from "shared/pages/teams/const/LMSCourseTypes";
import { ORIENTATION_TYPE } from "shared/components/FoldersDropdown/FoldersDropdown";
import { ProjectCardTools } from "shared/components/projectCard/ProjectCardTools";
import { isExternalTeamManager } from "shared/helpers/utils/ExternalTeamUtils";
import { TooltipList } from "./toolsStyles";
import { ButtonsWrapper } from "../styles";

export const ViewCardButton = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column-reverse;
  justify-content: space-between;
  cursor: pointer;
  max-width: 32px;

  @media (max-width: 940px) {
    max-width: initial;
    align-items: center;
    flex-direction: row;
    width: 100%;
    //padding: 0 16px;
    justify-content: center;
    box-sizing: border-box;
  }
`;

export const ToolBarItemWrapper = styled(ViewCardButton)<{ isBottomTooltip?: boolean, isModer?: boolean }>`

  line-height: 0;
  
  #tippy-7 { // центруем попал likes контроллера
    left: 2.5px !important;
  }


  .tippy-box {
    min-width: 240px;
    box-shadow: 0px 1px 4px rgba(7, 7, 7, 0.17);
    &[data-placement="top"] {
      *:after { 
        top: auto;
        bottom: -14px;
        transform: rotate(180deg);
      }
    }
  }

  &:not(:last-child) {
    margin-bottom: 16px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      margin-bottom: 8px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
      margin-bottom: 0;
      margin-left: 12px;
      ${IconWrapper} {
        margin-top: 0;
      }
    }
    @media (max-width: ${LayoutConst.screen.md}px) {
      margin-left: 0;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      margin-left: 12px;
      &.CreateProductButtonWrapper {
        ${p => !p.isBottomTooltip && css`
          margin-left: 0;`}
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    svg {
      width: 24px;
      height: 24px;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-bottom: 0;
  }
  .dropdown-element-popup{
    @media (max-width: ${LayoutConst.screen.s}px) {
      right: -200px;
    }
  }
`;

const ProjectActionsTooltipContent = styled(TooltipList)`
  width: 100%;
`;

const ProjectCardText = styled.span`
  font-size: 15px;
  line-height: 20px;
  ${Fonts.Inter.smallText};
  color: ${(p) => p.theme.icon.default};
  margin-top: 8px;
  max-width: 73px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 11px;
    line-height: 13px;
  }

  @media (max-width: 940px) {
    margin-top: 0;
    margin-right: 4px;
    max-width: unset;
  }
`

interface ProjectButtonsProps {
  project: Project;
  orientation?: 'horizontal' | 'vertical',
  dropdownPos?: 'left' | 'right',
  dropdownVerticalPos?: 'top' | 'bottom',
  isBottomTooltip?: boolean,
  isPresentationTooltip?: boolean;
  isProjectPage?: boolean,
  isPresentation?: boolean,
  isProjectButtons?: boolean,
  isOutsideTextPosition?: boolean,
  onShouldReload?: (project: Project) => void;
}

const ProjectButtons: FC<ProjectButtonsProps> = ({
  project,
  orientation = 'vertical',
  dropdownPos,
  dropdownVerticalPos,
  isBottomTooltip = false,
  isPresentationTooltip = false,
  isProjectPage = false,
  onShouldReload,
  isPresentation,
  isProjectButtons
}) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = useBreakpoint(940);
  const is834 = useBreakpoint(834);
  const is744 = useBreakpoint(LayoutConst.screen.s);
  const is743 = useBreakpoint(LayoutConst.screen.s - 1);
  const is1199 = useBreakpoint(LayoutConst.screen.l);
  const isTab = useBreakpoint(LayoutConst.screen.m);
  const is430 = useBreakpoint(430);
  const profile = useProfile();
  const modal = useModal();
  const theme = useTheme();
  const toasts = useToasts();
  const isAgeyTomesh = AppTester.isAgeytomesh();
  const isOnlines = AppTester.isOnlines();
  const isGeo = AppTester.isGeograffee();
  const isSuperPuper = AppTester.isSuperPuper();
  const isFtbl = AppTester.isFtbl();
  const isGeoDafes = AppTester.isGeoDafes();
  const isContinuumSite = AppTester.isContinuumSite();
  const isMedia = AppTester.isMediiia();
  const isPreview = !!useRouteMatch(['/preview', '/book-preview', '/books/book-preview']);
  const isBook = !!useRouteMatch(['/books', '/book']);
  const isBookEdit = !!useRouteMatch('/books/book-edit');
  const [childEntities, setChildEntities] = useState(project?.childEntities);
  const [isMoreTooltipOpen, setIsMoreTooltipOpen] = useState(false);
  const isPointerInsideMoreTooltipRef = useRef(false);
  const isNestedDropdownOpenRef = useRef(false);
  const moreTooltipCloseTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  /** >1199: close only on outside click. ≤1199 (tab and below): as before. */
  const closeOnClickOutsideOnly = !is1199;

  const clearMoreTooltipCloseTimer = useCallback(() => {
    if (moreTooltipCloseTimerRef.current) {
      clearTimeout(moreTooltipCloseTimerRef.current);
      moreTooltipCloseTimerRef.current = null;
    }
  }, []);

  const openMoreTooltip = useCallback(() => {
    clearMoreTooltipCloseTimer();
    setIsMoreTooltipOpen(true);
  }, [clearMoreTooltipCloseTimer]);

  const scheduleMoreTooltipClose = useCallback(() => {
    clearMoreTooltipCloseTimer();
    moreTooltipCloseTimerRef.current = setTimeout(() => {
      if (!isPointerInsideMoreTooltipRef.current && !isNestedDropdownOpenRef.current) {
        setIsMoreTooltipOpen(false);
      }
    }, 150);
  }, [clearMoreTooltipCloseTimer]);

  const handleNestedDropdownOpenChange = useCallback((isOpen: boolean) => {
    isNestedDropdownOpenRef.current = isOpen;

    if (isOpen) {
      openMoreTooltip();
    } else if (!closeOnClickOutsideOnly) {
      scheduleMoreTooltipClose();
    }
  }, [closeOnClickOutsideOnly, openMoreTooltip, scheduleMoreTooltipClose]);

  const closeMoreTooltip = useCallback(() => {
    clearMoreTooltipCloseTimer();
    isPointerInsideMoreTooltipRef.current = false;
    isNestedDropdownOpenRef.current = false;
    setIsMoreTooltipOpen(false);
  }, [clearMoreTooltipCloseTimer]);

  const handleMoreTooltipClickOutside = useCallback((_: any, event: MouseEvent) => {
    const target = event.target as HTMLElement | null;

    if (target?.closest('.dropdown-element-popup')) {
      return;
    }

    closeMoreTooltip();
  }, [closeMoreTooltip]);

  useEffect(() => clearMoreTooltipCloseTimer, [clearMoreTooltipCloseTimer]);
  const vtype = useSelector((state: any) => state.vt.projectVType);
  const isShouldPrintPresentation = useMemo(() => (['t-shape', 'fixed-ratio-large', 'fixed-ratio-small'].includes(vtype)), [vtype])
  const isOutsideTextPositionState = useSelector((state: any) => state.vt.isOutsideTextPosition);
  const onWhiteBg = !isGeo && !isSuperPuper;
  const isCollectionVote = useMemo(() => (project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN)), [project]);
  const lmsModuleInfo = useSelector(selectorLMSModuleInfo);

  const [lmsCourseFormula, setLmsCourseFormula] = useState<LMSCourseTypes>(LMSCourseTypes.BachelorsDegree);
  const [expressionName, setExpressionName] = useState<string>('DEFAULT_BACHELORS_DEGREE_WEIGHTS');
  useEffect(() => {
        //@ts-ignore
        setLmsCourseFormula(project?.teams?.[0]?.lmsCourseType)
    }, [project])

     useEffect(() => {
        switch (lmsCourseFormula) {
            case LMSCourseTypes.BachelorsDegree:
            case LMSCourseTypes.OnlineBachelorsDegre:
                setExpressionName('DEFAULT_BACHELORS_DEGREE_WEIGHTS');
                break;
            case LMSCourseTypes.MastersDegree:
                setExpressionName('DEFAULT_MASTERS_DEGREE_WEIGHTS');
                break;
            case LMSCourseTypes.AdditionalEducation:
                setExpressionName('DEFAULT_ADDITIONAL_EDUCATION_WEIGHTS');
                break;
            case LMSCourseTypes.ChildrensSchool:
            case LMSCourseTypes.Portfolio:
                setExpressionName('DEFAULT_SHORTINTENSIVE_COURSES_WEIGHTS');
                break;
            default:
                setExpressionName('DEFAULT_BACHELORS_DEGREE_WEIGHTS');
        }
    }, [lmsCourseFormula]);
  

  const { foldersList } = useSelector(ProfileFoldersSelector)
  const { onRemoveProject } = useFoldersController();

  const isChapter = useMemo(() => (!!project?.book), [project]);

  const history = useHistory();

  const isMe = project?.author?.accountId === (profile?.accountId ?? '-') || project?.coAuthors?.some((v: any) => v?.accountId === (profile?.accountId ?? '-'));

  const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);

  const isSuperPuperProject = useMemo(() => project?.contexts?.includes('super-puper-collection'), [project])

  const isExpertUser = useMemo(() => isExpert(profile, project?.tagsID), [profile, project?.tagsID]);
  // const isExternalManager = useMemo(() => isExternalTeamManager(profile, project?.authorId), [profile, project?.authorId]);
  const isExpertUserByPolicy = useMemo(() => isExpertByPolicy(profile, project?.tagsID), [profile, project?.tagsID]);

  const canDefencePrj = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.edit_project_defence)).containsIn(profile.rolesList)
  ), [profile]);

  const canDefenceBook = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.edit_defence_book)).containsIn(profile.rolesList)
  ), [profile]);

  const canGetStatisticForProject = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && ((new ProfileRole(HsePolicies.can_view_statistic_project)).containsIn(profile.rolesList) || isExpertUser)
  ), [profile, isExpertUser]);

  const canEditAllPrj = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.edit_project)).containsIn(profile.rolesList)
  ), [profile]);

  const canViewOrigImagesPrj = useMemo(
      () => profile && profile.rolesList && Array.isArray(profile.rolesList) &&
         (new ProfileRole(HsePolicies.can_view_originals_project)).containsIn(profile.rolesList)
    , [profile]);

  const isLMSProject = project?.contexts?.includes("lmsproject") || project?.contexts?.includes("lmshseproject")

  const hasLmsAdminPolicy  = useMemo(
    () => (profile && project && profile.rolesList && Array.isArray(profile.rolesList) &&
     (new ProfileRole(HsePolicies.lms_admin)).containsIn(profile.rolesList) &&
     isLMSProject
  ), [profile, project, isLMSProject]);
  
  const shouldVisibleProtectButton = isModer || ((!!project?.book) ? canDefenceBook : canDefencePrj);

  const canBeDraft = useMemo(() => !project?.bookId && !isBookEdit, [project, isBookEdit]);

  const isCreator = useMemo(() => project?.creatorId && project?.creatorId === profile?.accountId, [project, profile]);

  const isProjectOnDisplay = useMemo(() =>
    project && ProjectOnDisplay(project), [project])

  const isProjectPartInCompetition = useMemo(() =>
    //@ts-ignore
    (project && !project?.canEdit_PartCompetition), [project])

  const [canSendToVScompetition, competitionList] = useVsCompetition(project);

  const isCanVisibleCompetitionList = useMemo(
    () => (!!profile && (is743 && isModer)), [profile, is744, is743, isMobile, is834, isModer]);

  const isCanSendGift = useMemo(
    () => (!!profile && isMobile && isModer && isAgeyTomesh), [profile, isMobile, isModer, isAgeyTomesh])

  const showTabletLayout = useMemo(
    () => (isProjectPage && !isOnlines && !isBottomTooltip && is1199),
    [isProjectPage, isOnlines, isBottomTooltip, is1199]);

  const isSidebarButtonsHorizontal = useMemo(
    () => isProjectPage && is1199 && !is744 && !isBottomTooltip,
    [isProjectPage, is1199, is744, isBottomTooltip],
  );

  const buttonsWrapperDirection = useMemo(
    () => (isSidebarButtonsHorizontal || orientation === 'horizontal' ? 'row' : 'column'),
    [isSidebarButtonsHorizontal, orientation],
  );

  const inActiveState = useMemo(() => !!isPreview, [isPreview]);

  const isCoAuthor = useMemo(() => profile && project?.coAuthorIds?.includes(profile?.accountId), [project, profile])

  const isStudent = profile?.globalTypes?.includes('Student');

  const isEditable = useMemo(() =>
      !isAgeyTomesh
      && (isCreator || isMe 
          || (lmsModuleInfo?.teacherIds?.includes(profile?.accountId || '') && lmsModuleInfo?.moduleProjectId === project?.projectId)
          || ProjectDelegate.isProjectEditableFor(profile, project))
      && !BookDelegate?.isPaid(project)
    , [isAgeyTomesh, isCreator, isMe, project, profile, lmsModuleInfo])

  const isCanBeDraft = useMemo(() => canBeDraft 
      && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project))
      && !BookDelegate?.isPaid(project)
    , [canBeDraft, isAgeyTomesh, isCreator, isMe, project, profile])

  const canEditFolders = useMemo(() => {
    return (/*isMedia || */isMe)
  } , [isMedia, isMe])

  const canMakeBilingual = useMemo(() => 
    // @ts-ignore
      !project?.isBilingual
      && !project?.longreadId_en
      && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project))
      && !isBook
      && !BookDelegate?.isPaid(project)
    , [project, isMe, profile, isCreator, isBook])

  // @ts-ignore
  const isTagModerator = useMemo(() => !project?.book && profile && (bProfile.isModer(profile) || profile.tagListId?.some(x => project?.tagsID?.includes(x))
      // @ts-ignore
      || profile.tagListId_Expert?.some(x => project?.tagsID?.includes(x))), [project, profile])

  const isLongreadAndTeamOwner = useMemo(() => checkIsLongreadAndTeamOwner(project, profile?.accountId || "") && isModer, [isModer, project, profile])
  const isSuperModer = useMemo(() => profile && (
    bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile])

  const isProjectButtonHidden = useMemo(() => (
    [isCanSendGift, isCoAuthor, isTagModerator, canMakeBilingual, isEditable, isCanBeDraft, shouldVisibleProtectButton, isLongreadAndTeamOwner].every(i => !i)
    && (competitionList?.length === 0 || !canSendToVScompetition)
      && (!isSuperModer || !isModer)
      && (!profile || isMe)
  ), [isCanSendGift, isCoAuthor, isTagModerator, canMakeBilingual, competitionList, canSendToVScompetition, isEditable, isCanBeDraft, shouldVisibleProtectButton, isLongreadAndTeamOwner, isSuperModer, profile, isMe])

  const superPuperStyles = {...getTooltipStyles(theme), background: "#464645", backgroundColor: "#464645"}
  
  const hideRepostButton = isLMSProject || isCollectionVote

  const shouldShowRepostButton = !hideRepostButton && !isFtbl && !isTab;

  const hintProps: any = orientation === 'horizontal' ? {
    noArrow: true,
    positionY: 'top',
  } : {};

  const printPDFForm = useMemo(() => ({
    orientation: true,
    size: 'A4',
    localization: i18n.language,
    projectId: project?.projectId,
    isPresentation: isShouldPrintPresentation || false,
    isOutsideTextPosition: isOutsideTextPositionState || false,
  }), [project, i18n.language, isShouldPrintPresentation, isOutsideTextPositionState]);
  const printPdfCard = useCallback(() => {

    toasts.info(t('print_project_toast'))

    API.request()
      .endpoint(Endpoints.geograffee)
      .url('/api/Project/PrintPdf')
      .post()
      .body(printPDFForm)
      .send()
      .then((r) => r.json())
      .then((r) => r?.length > 0 ? downloadPDF(r, project?.title, toasts.error, toasts.info, t) : console.error('no files'))
      .catch((e) => console.error(e))
  }, [t, printPDFForm]);

  const onExport = useCallback(() => {
    modal.show('export-projects', { selectedByTab: { projects: [project.projectId] } });
  }, [project.projectId, modal]);

  const onTransfer = useCallback(() => {
    modal.show('transfer-project-link', { projectId: project.projectId, project });
  }, [project.projectId, project, modal]);

  const onRemoveFromFolders = async (projectId: string) => {
    if (!foldersList?.length) return;

    const initFolders = async () => {
      const data = await urlApi().fetchFolders(profile?.designerId ?? '')

      if (Array.isArray(data)) {
        dispatch(ProfileFoldersSlice.actions.setFolders(data))
      };
    }

    const tFolder = foldersList?.find((folder) => folder?.entityIds?.includes(projectId))

    if (tFolder) {
      onRemoveProject({...tFolder, entityIds: [projectId]}).then((r) => {
        initFolders();
      })
    }
  }

  const handleMoveToDrafts = (projectId: string) => {
    const confirmation = window.confirm(t('project.confirmation_msg.to_drafts'));
    if (confirmation) {
      isProjectPartInCompetition ?
        toasts.error(t('toasts.project_part_competition')) :
        ProjectAPI.UpdateStatus({ projectId, projectStatus: 0 }).then(
          () => {
            onRemoveFromFolders(projectId)
            history.push(
              CreateLinkTo.designerTab(
                profile?.accountId ?? 'undefined',
                isBook ? "draft_books" : 'drafts',
              ),
            );
            toasts.info(t('toasts.project_move_to_drafts'))
          },
        );
    }
  };

  const handleMakeBilingual = (projectId: string) => {
    if (!profile) return;
    const confirmation = window.confirm('Вы действительно хотите сделать проект двуязычным?');
    if (confirmation) {
      (isProjectOnDisplay && !(bProfile.isModer(profile) || ProjectDelegate.canEditShowcaseProjects(profile)))
        ? displayProjectEditError(project, toasts, t, i18n.language)
        : (history.push(CreateLinkTo.bilingual(projectId)))
    }
  }

  const handleSendToCompetition = (projectId: string, nominationsID?: string[]) => {
    isProjectPartInCompetition ?
      toasts.error(t('toasts.project_part_competition')) : new Promise((res, rej) => {
        const appr = window.confirm(t('toasts.project_approved_question'));
        if (appr) {
          API.request()
            .endpoint(Endpoints.competitions)
            .url('/api/Competition/Apply')
            .post()
            .addQuery('NominationID', nominationsID?.length ? nominationsID[0] : '')
            .addQuery('ProjectID', projectId)
            .send()
            .then((r) => {
              if (r.status === 200) {
                res(toasts.info(t('toasts.project_send_to_competition')))

                setTimeout(() => window.location.reload(), 1500)
              }
              if (r.status === 400) {
                rej(toasts.error(t('toasts.project_part_competition')))
              }
            })
            .catch((e) => rej(toasts.error(t('toasts.project_part_competition'))))
        } else {
          return false;
        }
      })
  }

  const handleRejectCoauthor = () => {
    const confirmation = window.confirm('Вы действительно хотите отказаться от соавторства?');
    if (confirmation) {
      API.request()
          .endpoint(Endpoints.geograffee)
          .url('/api/Project/RefuseCoAuthorship')
          .post()
          .body({
            projectId: project?.projectId || ''
          })
          .release()
          .then((r: any) => {
            if (r.status === 400 || r.status === 500) {
              toasts.error(t('toasts.project_reject_coauthor_error'))
              return;
            }
            toasts.info(t('toasts.project_reject_coauthor'))

            setTimeout(() => window.location.reload(), 1500)
          })
          .catch((e: any) => toasts.error(t('toasts.project_reject_coauthor_error')))
      }
  }

  const handleReport = () => {
    modal.show('report', {
      entityId: project.projectId,
      entityType: "project",
      handleClose: () => {
        modal.hide();
      }
    });
  }

  const handleAttachProducts = () => {
    modal.show('shop-sent', {
      project: project,
    });
  }

  const hideTransferProject = isBook || isChapter || isLMSProject || !!project?.isBook || !isEditable;

  const shouldDisplayTools = isLMSProject 
  ? (hasLmsAdminPolicy)
  : (profile && ProjectDelegate.shouldDisplayProjectToolsFor(profile, project) || isExpertUser || isExpertUserByPolicy);

  if (showTabletLayout) {
    return (
      <FlexBox align="stretch">
        <ButtonsWrapper
          justify="flex-start"
          direction={buttonsWrapperDirection}
          directionMobile={buttonsWrapperDirection}
          justifyMobile="center"
          alignMobile={'center'}
          align="center"
          isProjectPage
          className="buttons-wrapper"
          inActiveState={inActiveState}
          canEditFolders={canEditFolders}
          isBottomTooltip={isBottomTooltip}
          isPresentationTooltip={isPresentationTooltip}
        >
          {!!profile && (
            <ToolBarItemWrapper className="MoreButtonWrapper ps-action-btn" isBottomTooltip={isBottomTooltip}>
              {/* <MoreButton size="large"> */}
              {isProjectButtonHidden ? null : inActiveState ? (
                <IconWrapperSpecial2>
                  <MoreIcon/>
                </IconWrapperSpecial2>
              ) : (
                <Tooltip 
                  className="project-actions-tooltip"
                  visible={isMoreTooltipOpen}
                  onClickOutside={handleMoreTooltipClickOutside}
                  target={
                    <IconWrapperSpecial2
                      onClick={openMoreTooltip}
                      onMouseEnter={openMoreTooltip}
                      onMouseLeave={closeOnClickOutsideOnly ? undefined : scheduleMoreTooltipClose}
                    >
                      <MoreIcon/>
                    </IconWrapperSpecial2>
                  }
                >
                  <ProjectActionsTooltipContent
                    onMouseEnter={() => {
                      isPointerInsideMoreTooltipRef.current = true;
                      openMoreTooltip();
                    }}
                    onMouseLeave={() => {
                      isPointerInsideMoreTooltipRef.current = false;
                      if (!closeOnClickOutsideOnly) {
                        scheduleMoreTooltipClose();
                      }
                    }}
                  >
                    <ProjectTooltip
                    project={project}
                    identifier={project.projectId}
                    isCopyLink={true}
                    isEditable={isEditable}
                    isCanBeDraft={isCanBeDraft}
                    canModerSendToCompetition={canSendToVScompetition}
                    canTransfer={!hideTransferProject}
                    competitionList={competitionList}
                    // isProjectAITranslateRemovable={isProjectAITranslateRemovable}
                    isReportable={profile && !isMe}
                    isInOnDisplay={isProjectOnDisplay}
                    isPartInCompetition={isProjectPartInCompetition}
                    isLongreadAndTeamOwner={isLongreadAndTeamOwner}
                    canEditFolders={canEditFolders}
                    onReport={handleReport}
                    onExport={onExport}
                    onTransfer={onTransfer}
                    onAttachProducts={handleAttachProducts}
                    onMoveDrafts={handleMoveToDrafts}
                    onMakeBilingual={handleMakeBilingual}
                    onSendToCompetition={handleSendToCompetition}
                    canMakeBilingual={canMakeBilingual}
                    isCoauthor={isCoAuthor}
                    onRejectCoauthor={handleRejectCoauthor}
                      //@ts-ignore
                    isTagModerator={isTagModerator}
                    isSuperModer={isSuperModer || canEditAllPrj || hasLmsAdminPolicy}
                    isCanVisibleCompetitionList={isCanVisibleCompetitionList}
                    canSendGift={isCanSendGift}
                    canViewStatistic={canGetStatisticForProject}
                    shouldDisplayShowcases={shouldDisplayTools}
                    isCollectionVote={isCollectionVote}
                    toggleTooltip={handleNestedDropdownOpenChange}
                    portalNestedDropdowns
                    closeOnClickOutsideOnly={closeOnClickOutsideOnly}
                    onShouldReload={onShouldReload}
                    />
                  </ProjectActionsTooltipContent>
                </ Tooltip>
              )}
            </ToolBarItemWrapper>
          )}
          <>
            {shouldShowRepostButton && <ToolBarItemWrapper className="BookmarkButtonWrapper ps-action-btn">
              <RepostButton
                project={project}
                inActiveState={inActiveState}
              />
            </ToolBarItemWrapper>}
            {!isCollectionVote && !isFtbl && <ToolBarItemWrapper className="BookmarkButtonWrapper ps-action-btn">
              <BookmarkButton
                project={project}
                entityType={'project'}
                entityId={project.book ? project.book.bookId : project.projectId}
                inActiveState={inActiveState}
              />
            </ToolBarItemWrapper>}
            
            <ToolBarItemWrapper className="ShareButtonWrapper ps-action-btn">
              <IconWrapperSpecial2 onClick={inActiveState ? () => false : () => modal.show('share', {
                isBook: project?.isBook,
                project: project,
                projectId: project?.projectId,
                childEntities: childEntities,
                projectStatus: project?.status,
                setChildEntities: childEntities,
                isPresentation,
                onPrint: printPdfCard,
                title: project?.title,
                images: project?.titleImages,
              })}>
                <HintTooltip text={t(isCollectionVote ? "sharing.title_voting" : "hints.share")} z={8} {...hintProps}
                             noDisappearDelay={isBottomTooltip} positionY={is744 ? "bottom" : "default"}
                             customStyle={isCollectionVote ? superPuperStyles : isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)}
                             isPermanent={isCollectionVote && !isBottomTooltip} onWhiteBg={onWhiteBg}>
                  <ShareIcon/>
                </HintTooltip>
              </IconWrapperSpecial2>
            </ToolBarItemWrapper>

            {(isCreator || isModer) && !isCollectionVote && <ToolBarItemWrapper className="CreateProductButtonWrapper ps-action-btn">
                <IconWrapperSpecial2 
                  onClick={inActiveState ? () => false : () => createProductByProject(project.projectId)}
                  >
                  <HintTooltip text={t("hints.create_product")} z={8} {...hintProps}
                    noDisappearDelay={isBottomTooltip} positionY={is744 ? "bottom" : "default"}
                    isPermanent={isCollectionVote && !isBottomTooltip} onWhiteBg={onWhiteBg}>
                  <AddProductIcon />
                  </HintTooltip>
                </IconWrapperSpecial2>
              </ToolBarItemWrapper>} 
              
            {isCollectionVote && (
              <ProjectRatingsButton isBottomTooltip={isBottomTooltip} onWhiteBg={onWhiteBg}
                                    projectId={project?.projectId} tooltipProps={hintProps}/>
            )}
          </>
          <ToolBarItemWrapper className="LikesButtonWrapper ps-action-btn">
            <LikesController
              entityId={project.projectId}
              entityType="project"
              inActiveState={inActiveState}
              tooltipProps={hintProps}
            />
          </ToolBarItemWrapper>

          <ViewCount
              entityId={project.projectId}
              entityType="project"
              disabled={isBottomTooltip && !is743}
            />

        </ButtonsWrapper>
      </FlexBox>
    )
  }

  return (
    <>
      <FlexBox align="stretch">
        <ButtonsWrapper
          justify="flex-start"
          direction={buttonsWrapperDirection}
          directionMobile="row"
          justifyMobile="center"
          className="buttons-wrapper"
          alignMobile={orientation === 'vertical' ? 'center' : 'flex-start'}
          align="center"
          canEditFolders={canEditFolders}
          inActiveState={inActiveState}
          isProjectPage={isProjectPage}
          isPresentationTooltip={isPresentationTooltip}
          isPresentation={isPresentation}
          isProjectButtons={isProjectButtons}
        >
          {(isCreator || isModer) && !isCollectionVote && !isBottomTooltip && is743 && 
          <ToolBarItemWrapper isBottomTooltip={isBottomTooltip} className="CreateProductButtonWrapper ps-action-btn">
            <IconWrapperSpecial2 
              onClick={inActiveState ? () => false : () => createProductByProject(project.projectId)}
              >
              <HintTooltip text={t("hints.create_product")} z={8} {...hintProps}
                noDisappearDelay={isBottomTooltip} positionY={is744 ? "bottom" : "default"}
                isPermanent={isCollectionVote && !isBottomTooltip} onWhiteBg={onWhiteBg}>
              <AddProductIcon />
              </HintTooltip>
            </IconWrapperSpecial2>
          </ToolBarItemWrapper>} 

          {!!profile && (
            <ToolBarItemWrapper className="MoreButtonWrapper ps-action-btn" isBottomTooltip={isBottomTooltip}>
              {isProjectButtonHidden ? null : inActiveState ? (
                <IconWrapperSpecial2>
                  <MoreIcon/>
                </IconWrapperSpecial2>
              ) : (
                <Tooltip
                  className="project-actions-tooltip"
                  visible={isMoreTooltipOpen}
                  onClickOutside={handleMoreTooltipClickOutside}
                  target={
                    <IconWrapperSpecial2
                      onClick={openMoreTooltip}
                      onMouseEnter={openMoreTooltip}
                      onMouseLeave={closeOnClickOutsideOnly ? undefined : scheduleMoreTooltipClose}
                    >
                      <MoreIcon/>
                    </IconWrapperSpecial2>
                  }
                >
                  <ProjectActionsTooltipContent
                    onMouseEnter={() => {
                      isPointerInsideMoreTooltipRef.current = true;
                      openMoreTooltip();
                    }}
                    onMouseLeave={() => {
                      isPointerInsideMoreTooltipRef.current = false;
                      if (!closeOnClickOutsideOnly) {
                        scheduleMoreTooltipClose();
                      }
                    }}
                  >
                    <ProjectTooltip
                    project={project}
                    identifier={project.projectId}
                    isCopyLink={true}
                    isEditable={isEditable}
                    isCanBeDraft={isCanBeDraft}
                    canEditFolders={canEditFolders}
                    canModerSendToCompetition={canSendToVScompetition}
                    competitionList={competitionList}
                    isLongreadAndTeamOwner={isLongreadAndTeamOwner}
                    isReportable={profile && !isMe}
                    isInOnDisplay={isProjectOnDisplay}
                    orientationType={ORIENTATION_TYPE.project}
                    isPartInCompetition={isProjectPartInCompetition}
                    //repostTools={repostTools}
                    // onRepostRemove={onRepostRemove}
                    onDeleteAITranslation={
                      (id: string) => {
                        const confirmation = window.confirm(t('project.confirmation_msg.delete_translation'))
                        if (confirmation) {
                          API.fetch(
                            `${Endpoints.geograffee}/api/Project/RevertAutoTranslation?projectId=${id}`,
                            {
                              method: 'GET',
                            },
                          ).then(res => window.location.reload())
                        }                        
                      }
                    }
                    onReport={handleReport}
                    canTransfer={!hideTransferProject}
                    onExport={onExport}
                    onTransfer={onTransfer}
                    onAttachProducts={handleAttachProducts}
                    onMoveDrafts={handleMoveToDrafts}
                    onMakeBilingual={handleMakeBilingual}
                    onProtect={(projectId) => {
                      const isBook = project?.isBook;
                      const action = !!(project as any)?.isProtected? 'disabled' : 'enabled';

                      const isCantBeDisabled = (project as any)?.protectedStatus === protectProcessStatuses.InProcess;

                      if (isCantBeDisabled) {
                        // toasts.error(t('toasts.can_be_disabled_protect'));
                        return;
                      }

                      //@ts-ignore
                      const confirmation = window.confirm(t(!!project?.isProtected ? 'toasts.user_wont_unprotect' : 'toasts.user_wont_protect'));
                      
                      if (confirmation) {
                        const book = isBook && !isChapter;
                        API.request()
                          .endpoint(Endpoints.geograffee)
                          .url(`/api/${book ? 'Book' : 'Project'}/Protect`)
                          .post()
                          .body({
                            projectId,
                            action: protectStatuses[action]
                          })
                          .send()
                          .then((r) => {
                            if (r?.status === 403) {                              
                              toasts.error(t('project_edit.frames.permissions_protect'));
                              return;
                            }
                            window.location.reload();
                          });
                      }
                    }}
                    onSendToCompetition={handleSendToCompetition}
                    isCoauthor={isCoAuthor}
                    onRejectCoauthor={handleRejectCoauthor}
                    canMakeBilingual={canMakeBilingual}
                    isTagModerator={isTagModerator}
                    isSuperModer={isSuperModer || canEditAllPrj || hasLmsAdminPolicy}
                    //  isCanVisibleCompetitionList={isCanVisibleCompetitionList}
                    shouldVisibleProtectButton={shouldVisibleProtectButton}
                    canSendGift={isCanSendGift}
                    onShowOriginals={isModer || canEditAllPrj || hasLmsAdminPolicy || canViewOrigImagesPrj ? () => {
                      dispatch(CurrentProjectActions.setOriginalsState({ value: true }))
                      toasts.info('Показаны оригиналы изображений')
                    } : undefined}                    
                    canViewStatistic={canGetStatisticForProject}
                    shouldDisplayShowcases={shouldDisplayTools}
                    isCollectionVote={isCollectionVote}
                    toggleTooltip={handleNestedDropdownOpenChange}
                    portalNestedDropdowns
                    closeOnClickOutsideOnly={closeOnClickOutsideOnly}
                    onShouldReload={onShouldReload}
                    />
                  </ProjectActionsTooltipContent>
                </Tooltip>
              )}
            </ToolBarItemWrapper>
          )}

          {(isBottomTooltip || !isMobile) && (
            <>
              {shouldShowRepostButton && <ToolBarItemWrapper className="BookmarkButtonWrapper ps-action-btn">
                 <RepostButton
                    isFill
                    project={project}
                    inActiveState={inActiveState}
                  />
              </ToolBarItemWrapper>}
              {!isSuperPuperProject && !isFtbl && <ToolBarItemWrapper className="BookmarkButtonWrapper ps-action-btn">
                <HintTooltip customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} text={t("hints.bookmark")} z={9} noDisappearDelay={isBottomTooltip} onWhiteBg={onWhiteBg} {...hintProps}>

                  <BookmarkButton
                    project={project}
                    entityType={'project'}
                    entityId={project.book ? project.book.bookId : project.projectId}
                    inActiveState={inActiveState}
                  />
                </HintTooltip>
              </ToolBarItemWrapper>}
              <ToolBarItemWrapper className="ShareButtonWrapper ps-action-btn">
                <IconWrapperSpecial2 onClick={inActiveState ? () => false : () => modal.show('share', {
                  isBook: project?.isBook,
                  project: project,
                  projectId: project?.projectId,
                  childEntities: childEntities,
                  projectStatus: project?.status,
                  setChildEntities: setChildEntities,
                  isPresentation,
                  onPrint: printPdfCard,
                  title: project?.title,
                  images: project?.titleImages,
                  cardId: project?.cardId,
                })}>
                   <HintTooltip customStyle={isCollectionVote ? superPuperStyles : isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} text={t(isCollectionVote ? "sharing.title_voting" : "hints.share")} z={8}
                               noDisappearDelay={isBottomTooltip} positionY={is744 ? "bottom" : "default"}
                               isPermanent={isCollectionVote && !isBottomTooltip} onWhiteBg={onWhiteBg} {...hintProps}>
                    <ShareIcon/>
                  </HintTooltip>
                </IconWrapperSpecial2>
              </ToolBarItemWrapper>
              {(isCreator || isModer) && !isCollectionVote && <ToolBarItemWrapper isBottomTooltip={isBottomTooltip} className="CreateProductButtonWrapper ps-action-btn">
                <IconWrapperSpecial2 
                  onClick={inActiveState ? () => false : () => createProductByProject(project.projectId)}
                  >
                  <HintTooltip text={t("hints.create_product")} z={8} {...hintProps}
                    noDisappearDelay={isBottomTooltip} positionY={is744 ? "bottom" : "default"}
                    isPermanent={isCollectionVote && !isBottomTooltip} onWhiteBg={onWhiteBg}>
                  <AddProductIcon />
                  </HintTooltip>
                </IconWrapperSpecial2>
              </ToolBarItemWrapper>} 
              {isLMSProject && isStudent && <ToolBarItemWrapper className="LMSGradeButtonWrapper ps-action-btn">
                <IconWrapperSpecial2 
                  onClick={inActiveState ? () => false : () => modal.show('formula', { moduleId: lmsModuleInfo?.moduleProjectId, expressionName: expressionName, isStudentView: true })}
                  >
                  <HintTooltip text={t("hints.lms_grade")} z={8} {...hintProps}
                    noDisappearDelay={isBottomTooltip} positionY={is744 ? "bottom" : "default"}
                    onWhiteBg={onWhiteBg}>
                  <LMSGradeIcon />
                  </HintTooltip>
                </IconWrapperSpecial2>
              </ToolBarItemWrapper>}
              {isCollectionVote && (
                <ProjectRatingsButton isBottomTooltip={isBottomTooltip} onWhiteBg={onWhiteBg}
                                      projectId={project?.projectId} tooltipProps={hintProps} />
              )}
            </>
          )}
          {(isBottomTooltip || (!isMobile && !isOnlines)) && (
            <ToolBarItemWrapper className="LikesButtonWrapper ps-action-btn">
              <LikesController
                entityId={project.projectId}
                entityType="project"
                inActiveState={inActiveState}
                tooltipProps={hintProps}
              />
            </ToolBarItemWrapper>
          )}

          {(isBottomTooltip || !isMobile) && (
              <ViewCount
                entityId={project.projectId}
                entityType="project"
                disabled={isBottomTooltip && !is743}
                toolTipProps={hintProps}
              />
          )}

        </ButtonsWrapper>
      </FlexBox>
    </>
  );
}

export default memo(ProjectButtons);import React, { FC, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Dropdown,
  FlexBox,
  Fonts,
  HintTooltip,
  Tooltip,
  useBreakpoint,
  useIsMobile,
  useToasts
} from "@brg/ui";
import { useTranslation } from 'react-i18next';
import { ProjectTooltip } from "../../../components/tooltips";
import { ProjectDelegate } from "../../../../project-delegate";
import { API, Endpoints, Project, ProjectAPI, Team } from "@brg/api";
import { CreateLinkTo } from "../../../constants/linkTo";
import { bProfile, useProfile, ProfileUtils, ProfileRole } from "@brg/auth";
import BookmarkButton from "../../../components/bookmarkButton/bookmarkButton";
import ViewCount from "../../../components/viewCount/ViewCount";
import { LikesController } from "../../../../core/modules/likes.module";
import { ProjectOnDisplay } from '../../../helpers/projectStatus';
import { IconWrapper, IconWrapperSpecial2 } from "../../../assets/styles";
import styled, { useTheme, css } from "styled-components";
import { useHistory, useRouteMatch } from "react-router-dom";
import { LayoutConst, useModal } from "core";
import { displayProjectEditError } from "../../../components/tooltips/ProjectTooltip";
import { AppTester } from '../../../../supporting';
import { useDispatch, useSelector } from "react-redux";
import { useVsCompetition } from "shared/hooks/useVsCompetition";
import { downloadPDF } from "../../../components/PrintProject/model/downloadPDF";
import { SP_VOTE_COLLECTION_SIGN } from "../../VotesAdmin/constants";
import { MoreIcon } from "../../../icons/projectToolsWithResize/MoreIcon";
import { ShareIcon } from "../../../icons/projectToolsWithResize/ShareIcon";
import { ProjectRatingsButton } from "./ProjectRatingsButton";
import { checkIsLongreadAndTeamOwner } from "../../../helpers/designer/checkIsLongreadAndTeamOwner";
import { CurrentProjectActions } from "../../../reducers/CurrentProject";
import { getTooltipStyles, tooptipStylesWhite } from "shared/constants/tooptipStyles";
import {BookDelegate} from "../../../../_deziiign/books/core/book-delegate";
import { protectProcessStatuses, protectStatuses } from "shared/helpers/protectStatus";
import {selectorLMSModuleInfo} from "../../../reducers/LMSSlice";
import { HsePolicies } from "shared/constants/HsePolicies";
import { isExpert, isExpertByPolicy } from "shared/helpers/utils/TagsUtils";
import ProfileFoldersSlice, { ProfileFoldersSelector } from "shared/reducers/ProfileFoldersSlice";
import { useFoldersController } from "shared/hooks/useFoldersController";
import urlApi from "shared/actions/urlApi";
import { AddProductIcon } from "shared/icons/projectToolsWithResize/AddProductIcon";
import { createProductByProject } from "shared/helpers/CreateProductByProject";
import RepostButton from "shared/components/repostButton/repostButton";
import { LMSGradeIcon } from "shared/icons/projectToolsWithResize/LMSGradeIcon";
import { LMSCourseTypes } from "shared/pages/teams/const/LMSCourseTypes";
import { ORIENTATION_TYPE } from "shared/components/FoldersDropdown/FoldersDropdown";
import { ProjectCardTools } from "shared/components/projectCard/ProjectCardTools";
import { isExternalTeamManager } from "shared/helpers/utils/ExternalTeamUtils";
import { TooltipList } from "./toolsStyles";
import { ButtonsWrapper } from "../styles";

export const ViewCardButton = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column-reverse;
  justify-content: space-between;
  cursor: pointer;
  max-width: 32px;

  @media (max-width: 940px) {
    max-width: initial;
    align-items: center;
    flex-direction: row;
    width: 100%;
    //padding: 0 16px;
    justify-content: center;
    box-sizing: border-box;
  }
`;

export const ToolBarItemWrapper = styled(ViewCardButton)<{ isBottomTooltip?: boolean, isModer?: boolean }>`

  line-height: 0;
  
  #tippy-7 { // центруем попал likes контроллера
    left: 2.5px !important;
  }


  .tippy-box {
    min-width: 240px;
    box-shadow: 0px 1px 4px rgba(7, 7, 7, 0.17);
    &[data-placement="top"] {
      *:after { 
        top: auto;
        bottom: -14px;
        transform: rotate(180deg);
      }
    }
  }

  &:not(:last-child) {
    margin-bottom: 16px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      margin-bottom: 8px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
      margin-bottom: 0;
      margin-left: 12px;
      ${IconWrapper} {
        margin-top: 0;
      }
    }
    @media (max-width: ${LayoutConst.screen.md}px) {
      margin-left: 0;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      margin-left: 12px;
      &.CreateProductButtonWrapper {
        ${p => !p.isBottomTooltip && css`
          margin-left: 0;`}
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    svg {
      width: 24px;
      height: 24px;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-bottom: 0;
  }
  .dropdown-element-popup{
    @media (max-width: ${LayoutConst.screen.s}px) {
      right: -200px;
    }
  }
`;

const ProjectActionsTooltipContent = styled(TooltipList)`
  width: 100%;
`;

const ProjectCardText = styled.span`
  font-size: 15px;
  line-height: 20px;
  ${Fonts.Inter.smallText};
  color: ${(p) => p.theme.icon.default};
  margin-top: 8px;
  max-width: 73px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 11px;
    line-height: 13px;
  }

  @media (max-width: 940px) {
    margin-top: 0;
    margin-right: 4px;
    max-width: unset;
  }
`

interface ProjectButtonsProps {
  project: Project;
  orientation?: 'horizontal' | 'vertical',
  dropdownPos?: 'left' | 'right',
  dropdownVerticalPos?: 'top' | 'bottom',
  isBottomTooltip?: boolean,
  isPresentationTooltip?: boolean;
  isProjectPage?: boolean,
  isPresentation?: boolean,
  isProjectButtons?: boolean,
  isOutsideTextPosition?: boolean,
  onShouldReload?: (project: Project) => void;
}

const ProjectButtons: FC<ProjectButtonsProps> = ({
  project,
  orientation = 'vertical',
  dropdownPos,
  dropdownVerticalPos,
  isBottomTooltip = false,
  isPresentationTooltip = false,
  isProjectPage = false,
  onShouldReload,
  isPresentation,
  isProjectButtons
}) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = useBreakpoint(940);
  const is834 = useBreakpoint(834);
  const is744 = useBreakpoint(LayoutConst.screen.s);
  const is743 = useBreakpoint(LayoutConst.screen.s - 1);
  const is1199 = useBreakpoint(LayoutConst.screen.l);
  const isTab = useBreakpoint(LayoutConst.screen.m);
  const is430 = useBreakpoint(430);
  const profile = useProfile();
  const modal = useModal();
  const theme = useTheme();
  const toasts = useToasts();
  const isAgeyTomesh = AppTester.isAgeytomesh();
  const isOnlines = AppTester.isOnlines();
  const isGeo = AppTester.isGeograffee();
  const isSuperPuper = AppTester.isSuperPuper();
  const isFtbl = AppTester.isFtbl();
  const isGeoDafes = AppTester.isGeoDafes();
  const isContinuumSite = AppTester.isContinuumSite();
  const isMedia = AppTester.isMediiia();
  const isPreview = !!useRouteMatch(['/preview', '/book-preview', '/books/book-preview']);
  const isBook = !!useRouteMatch(['/books', '/book']);
  const isBookEdit = !!useRouteMatch('/books/book-edit');
  const [childEntities, setChildEntities] = useState(project?.childEntities);
  const [isMoreTooltipOpen, setIsMoreTooltipOpen] = useState(false);
  const isPointerInsideMoreTooltipRef = useRef(false);
  const isNestedDropdownOpenRef = useRef(false);
  const moreTooltipCloseTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  /** >1199: close only on outside click. ≤1199 (tab and below): as before. */
  const closeOnClickOutsideOnly = !is1199;

  const clearMoreTooltipCloseTimer = useCallback(() => {
    if (moreTooltipCloseTimerRef.current) {
      clearTimeout(moreTooltipCloseTimerRef.current);
      moreTooltipCloseTimerRef.current = null;
    }
  }, []);

  const openMoreTooltip = useCallback(() => {
    clearMoreTooltipCloseTimer();
    setIsMoreTooltipOpen(true);
  }, [clearMoreTooltipCloseTimer]);

  const scheduleMoreTooltipClose = useCallback(() => {
    clearMoreTooltipCloseTimer();
    moreTooltipCloseTimerRef.current = setTimeout(() => {
      if (!isPointerInsideMoreTooltipRef.current && !isNestedDropdownOpenRef.current) {
        setIsMoreTooltipOpen(false);
      }
    }, 150);
  }, [clearMoreTooltipCloseTimer]);

  const handleNestedDropdownOpenChange = useCallback((isOpen: boolean) => {
    isNestedDropdownOpenRef.current = isOpen;

    if (isOpen) {
      openMoreTooltip();
    } else if (!closeOnClickOutsideOnly) {
      scheduleMoreTooltipClose();
    }
  }, [closeOnClickOutsideOnly, openMoreTooltip, scheduleMoreTooltipClose]);

  const closeMoreTooltip = useCallback(() => {
    clearMoreTooltipCloseTimer();
    isPointerInsideMoreTooltipRef.current = false;
    isNestedDropdownOpenRef.current = false;
    setIsMoreTooltipOpen(false);
  }, [clearMoreTooltipCloseTimer]);

  const handleMoreTooltipClickOutside = useCallback((_: any, event: MouseEvent) => {
    const target = event.target as HTMLElement | null;

    if (target?.closest('.dropdown-element-popup')) {
      return;
    }

    closeMoreTooltip();
  }, [closeMoreTooltip]);

  useEffect(() => clearMoreTooltipCloseTimer, [clearMoreTooltipCloseTimer]);
  const vtype = useSelector((state: any) => state.vt.projectVType);
  const isShouldPrintPresentation = useMemo(() => (['t-shape', 'fixed-ratio-large', 'fixed-ratio-small'].includes(vtype)), [vtype])
  const isOutsideTextPositionState = useSelector((state: any) => state.vt.isOutsideTextPosition);
  const onWhiteBg = !isGeo && !isSuperPuper;
  const isCollectionVote = useMemo(() => (project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN)), [project]);
  const lmsModuleInfo = useSelector(selectorLMSModuleInfo);

  const [lmsCourseFormula, setLmsCourseFormula] = useState<LMSCourseTypes>(LMSCourseTypes.BachelorsDegree);
  const [expressionName, setExpressionName] = useState<string>('DEFAULT_BACHELORS_DEGREE_WEIGHTS');
  useEffect(() => {
        //@ts-ignore
        setLmsCourseFormula(project?.teams?.[0]?.lmsCourseType)
    }, [project])

     useEffect(() => {
        switch (lmsCourseFormula) {
            case LMSCourseTypes.BachelorsDegree:
            case LMSCourseTypes.OnlineBachelorsDegre:
                setExpressionName('DEFAULT_BACHELORS_DEGREE_WEIGHTS');
                break;
            case LMSCourseTypes.MastersDegree:
                setExpressionName('DEFAULT_MASTERS_DEGREE_WEIGHTS');
                break;
            case LMSCourseTypes.AdditionalEducation:
                setExpressionName('DEFAULT_ADDITIONAL_EDUCATION_WEIGHTS');
                break;
            case LMSCourseTypes.ChildrensSchool:
            case LMSCourseTypes.Portfolio:
                setExpressionName('DEFAULT_SHORTINTENSIVE_COURSES_WEIGHTS');
                break;
            default:
                setExpressionName('DEFAULT_BACHELORS_DEGREE_WEIGHTS');
        }
    }, [lmsCourseFormula]);
  

  const { foldersList } = useSelector(ProfileFoldersSelector)
  const { onRemoveProject } = useFoldersController();

  const isChapter = useMemo(() => (!!project?.book), [project]);

  const history = useHistory();

  const isMe = project?.author?.accountId === (profile?.accountId ?? '-') || project?.coAuthors?.some((v: any) => v?.accountId === (profile?.accountId ?? '-'));

  const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);

  const isSuperPuperProject = useMemo(() => project?.contexts?.includes('super-puper-collection'), [project])

  const isExpertUser = useMemo(() => isExpert(profile, project?.tagsID), [profile, project?.tagsID]);
  // const isExternalManager = useMemo(() => isExternalTeamManager(profile, project?.authorId), [profile, project?.authorId]);
  const isExpertUserByPolicy = useMemo(() => isExpertByPolicy(profile, project?.tagsID), [profile, project?.tagsID]);

  const canDefencePrj = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.edit_project_defence)).containsIn(profile.rolesList)
  ), [profile]);

  const canDefenceBook = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.edit_defence_book)).containsIn(profile.rolesList)
  ), [profile]);

  const canGetStatisticForProject = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && ((new ProfileRole(HsePolicies.can_view_statistic_project)).containsIn(profile.rolesList) || isExpertUser)
  ), [profile, isExpertUser]);

  const canEditAllPrj = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.edit_project)).containsIn(profile.rolesList)
  ), [profile]);

  const canViewOrigImagesPrj = useMemo(
      () => profile && profile.rolesList && Array.isArray(profile.rolesList) &&
         (new ProfileRole(HsePolicies.can_view_originals_project)).containsIn(profile.rolesList)
    , [profile]);

  const isLMSProject = project?.contexts?.includes("lmsproject") || project?.contexts?.includes("lmshseproject")

  const hasLmsAdminPolicy  = useMemo(
    () => (profile && project && profile.rolesList && Array.isArray(profile.rolesList) &&
     (new ProfileRole(HsePolicies.lms_admin)).containsIn(profile.rolesList) &&
     isLMSProject
  ), [profile, project, isLMSProject]);
  
  const shouldVisibleProtectButton = isModer || ((!!project?.book) ? canDefenceBook : canDefencePrj);

  const canBeDraft = useMemo(() => !project?.bookId && !isBookEdit, [project, isBookEdit]);

  const isCreator = useMemo(() => project?.creatorId && project?.creatorId === profile?.accountId, [project, profile]);

  const isProjectOnDisplay = useMemo(() =>
    project && ProjectOnDisplay(project), [project])

  const isProjectPartInCompetition = useMemo(() =>
    //@ts-ignore
    (project && !project?.canEdit_PartCompetition), [project])

  const [canSendToVScompetition, competitionList] = useVsCompetition(project);

  const isCanVisibleCompetitionList = useMemo(
    () => (!!profile && (is743 && isModer)), [profile, is744, is743, isMobile, is834, isModer]);

  const isCanSendGift = useMemo(
    () => (!!profile && isMobile && isModer && isAgeyTomesh), [profile, isMobile, isModer, isAgeyTomesh])

  const showTabletLayout = useMemo(
    () => (isProjectPage && !isOnlines && !isBottomTooltip && is1199),
    [isProjectPage, isOnlines, isBottomTooltip, is1199]);

  const isSidebarButtonsHorizontal = useMemo(
    () => isProjectPage && is1199 && !is744 && !isBottomTooltip,
    [isProjectPage, is1199, is744, isBottomTooltip],
  );

  const buttonsWrapperDirection = useMemo(
    () => (isSidebarButtonsHorizontal || orientation === 'horizontal' ? 'row' : 'column'),
    [isSidebarButtonsHorizontal, orientation],
  );

  const inActiveState = useMemo(() => !!isPreview, [isPreview]);

  const isCoAuthor = useMemo(() => profile && project?.coAuthorIds?.includes(profile?.accountId), [project, profile])

  const isStudent = profile?.globalTypes?.includes('Student');

  const isEditable = useMemo(() =>
      !isAgeyTomesh
      && (isCreator || isMe 
          || (lmsModuleInfo?.teacherIds?.includes(profile?.accountId || '') && lmsModuleInfo?.moduleProjectId === project?.projectId)
          || ProjectDelegate.isProjectEditableFor(profile, project))
      && !BookDelegate?.isPaid(project)
    , [isAgeyTomesh, isCreator, isMe, project, profile, lmsModuleInfo])

  const isCanBeDraft = useMemo(() => canBeDraft 
      && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project))
      && !BookDelegate?.isPaid(project)
    , [canBeDraft, isAgeyTomesh, isCreator, isMe, project, profile])

  const canEditFolders = useMemo(() => {
    return (/*isMedia || */isMe)
  } , [isMedia, isMe])

  const canMakeBilingual = useMemo(() => 
    // @ts-ignore
      !project?.isBilingual
      && !project?.longreadId_en
      && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project))
      && !isBook
      && !BookDelegate?.isPaid(project)
    , [project, isMe, profile, isCreator, isBook])

  // @ts-ignore
  const isTagModerator = useMemo(() => !project?.book && profile && (bProfile.isModer(profile) || profile.tagListId?.some(x => project?.tagsID?.includes(x))
      // @ts-ignore
      || profile.tagListId_Expert?.some(x => project?.tagsID?.includes(x))), [project, profile])

  const isLongreadAndTeamOwner = useMemo(() => checkIsLongreadAndTeamOwner(project, profile?.accountId || "") && isModer, [isModer, project, profile])
  const isSuperModer = useMemo(() => profile && (
    bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile])

  const isProjectButtonHidden = useMemo(() => (
    [isCanSendGift, isCoAuthor, isTagModerator, canMakeBilingual, isEditable, isCanBeDraft, shouldVisibleProtectButton, isLongreadAndTeamOwner].every(i => !i)
    && (competitionList?.length === 0 || !canSendToVScompetition)
      && (!isSuperModer || !isModer)
      && (!profile || isMe)
  ), [isCanSendGift, isCoAuthor, isTagModerator, canMakeBilingual, competitionList, canSendToVScompetition, isEditable, isCanBeDraft, shouldVisibleProtectButton, isLongreadAndTeamOwner, isSuperModer, profile, isMe])

  const superPuperStyles = {...getTooltipStyles(theme), background: "#464645", backgroundColor: "#464645"}
  
  const hideRepostButton = isLMSProject || isCollectionVote

  const shouldShowRepostButton = !hideRepostButton && !isFtbl && !isTab;

  const hintProps: any = orientation === 'horizontal' ? {
    noArrow: true,
    positionY: 'top',
  } : {};

  const printPDFForm = useMemo(() => ({
    orientation: true,
    size: 'A4',
    localization: i18n.language,
    projectId: project?.projectId,
    isPresentation: isShouldPrintPresentation || false,
    isOutsideTextPosition: isOutsideTextPositionState || false,
  }), [project, i18n.language, isShouldPrintPresentation, isOutsideTextPositionState]);
  const printPdfCard = useCallback(() => {

    toasts.info(t('print_project_toast'))

    API.request()
      .endpoint(Endpoints.geograffee)
      .url('/api/Project/PrintPdf')
      .post()
      .body(printPDFForm)
      .send()
      .then((r) => r.json())
      .then((r) => r?.length > 0 ? downloadPDF(r, project?.title, toasts.error, toasts.info, t) : console.error('no files'))
      .catch((e) => console.error(e))
  }, [t, printPDFForm]);

  const onExport = useCallback(() => {
    modal.show('export-projects', { selectedByTab: { projects: [project.projectId] } });
  }, [project.projectId, modal]);

  const onTransfer = useCallback(() => {
    modal.show('transfer-project-link', { projectId: project.projectId, project });
  }, [project.projectId, project, modal]);

  const onRemoveFromFolders = async (projectId: string) => {
    if (!foldersList?.length) return;

    const initFolders = async () => {
      const data = await urlApi().fetchFolders(profile?.designerId ?? '')

      if (Array.isArray(data)) {
        dispatch(ProfileFoldersSlice.actions.setFolders(data))
      };
    }

    const tFolder = foldersList?.find((folder) => folder?.entityIds?.includes(projectId))

    if (tFolder) {
      onRemoveProject({...tFolder, entityIds: [projectId]}).then((r) => {
        initFolders();
      })
    }
  }

  const handleMoveToDrafts = (projectId: string) => {
    const confirmation = window.confirm(t('project.confirmation_msg.to_drafts'));
    if (confirmation) {
      isProjectPartInCompetition ?
        toasts.error(t('toasts.project_part_competition')) :
        ProjectAPI.UpdateStatus({ projectId, projectStatus: 0 }).then(
          () => {
            onRemoveFromFolders(projectId)
            history.push(
              CreateLinkTo.designerTab(
                profile?.accountId ?? 'undefined',
                isBook ? "draft_books" : 'drafts',
              ),
            );
            toasts.info(t('toasts.project_move_to_drafts'))
          },
        );
    }
  };

  const handleMakeBilingual = (projectId: string) => {
    if (!profile) return;
    const confirmation = window.confirm('Вы действительно хотите сделать проект двуязычным?');
    if (confirmation) {
      (isProjectOnDisplay && !(bProfile.isModer(profile) || ProjectDelegate.canEditShowcaseProjects(profile)))
        ? displayProjectEditError(project, toasts, t, i18n.language)
        : (history.push(CreateLinkTo.bilingual(projectId)))
    }
  }

  const handleSendToCompetition = (projectId: string, nominationsID?: string[]) => {
    isProjectPartInCompetition ?
      toasts.error(t('toasts.project_part_competition')) : new Promise((res, rej) => {
        const appr = window.confirm(t('toasts.project_approved_question'));
        if (appr) {
          API.request()
            .endpoint(Endpoints.competitions)
            .url('/api/Competition/Apply')
            .post()
            .addQuery('NominationID', nominationsID?.length ? nominationsID[0] : '')
            .addQuery('ProjectID', projectId)
            .send()
            .then((r) => {
              if (r.status === 200) {
                res(toasts.info(t('toasts.project_send_to_competition')))

                setTimeout(() => window.location.reload(), 1500)
              }
              if (r.status === 400) {
                rej(toasts.error(t('toasts.project_part_competition')))
              }
            })
            .catch((e) => rej(toasts.error(t('toasts.project_part_competition'))))
        } else {
          return false;
        }
      })
  }

  const handleRejectCoauthor = () => {
    const confirmation = window.confirm('Вы действительно хотите отказаться от соавторства?');
    if (confirmation) {
      API.request()
          .endpoint(Endpoints.geograffee)
          .url('/api/Project/RefuseCoAuthorship')
          .post()
          .body({
            projectId: project?.projectId || ''
          })
          .release()
          .then((r: any) => {
            if (r.status === 400 || r.status === 500) {
              toasts.error(t('toasts.project_reject_coauthor_error'))
              return;
            }
            toasts.info(t('toasts.project_reject_coauthor'))

            setTimeout(() => window.location.reload(), 1500)
          })
          .catch((e: any) => toasts.error(t('toasts.project_reject_coauthor_error')))
      }
  }

  const handleReport = () => {
    modal.show('report', {
      entityId: project.projectId,
      entityType: "project",
      handleClose: () => {
        modal.hide();
      }
    });
  }

  const handleAttachProducts = () => {
    modal.show('shop-sent', {
      project: project,
    });
  }

  const hideTransferProject = isBook || isChapter || isLMSProject || !!project?.isBook || !isEditable;

  const shouldDisplayTools = isLMSProject 
  ? (hasLmsAdminPolicy)
  : (profile && ProjectDelegate.shouldDisplayProjectToolsFor(profile, project) || isExpertUser || isExpertUserByPolicy);

  if (showTabletLayout) {
    return (
      <FlexBox align="stretch">
        <ButtonsWrapper
          justify="flex-start"
          direction={buttonsWrapperDirection}
          directionMobile={buttonsWrapperDirection}
          justifyMobile="center"
          alignMobile={'center'}
          align="center"
          isProjectPage
          className="buttons-wrapper"
          inActiveState={inActiveState}
          canEditFolders={canEditFolders}
          isBottomTooltip={isBottomTooltip}
          isPresentationTooltip={isPresentationTooltip}
        >
          {!!profile && (
            <ToolBarItemWrapper className="MoreButtonWrapper ps-action-btn" isBottomTooltip={isBottomTooltip}>
              {/* <MoreButton size="large"> */}
              {isProjectButtonHidden ? null : inActiveState ? (
                <IconWrapperSpecial2>
                  <MoreIcon/>
                </IconWrapperSpecial2>
              ) : (
                <Tooltip 
                  className="project-actions-tooltip"
                  visible={isMoreTooltipOpen}
                  onClickOutside={handleMoreTooltipClickOutside}
                  target={
                    <IconWrapperSpecial2
                      onClick={openMoreTooltip}
                      onMouseEnter={openMoreTooltip}
                      onMouseLeave={closeOnClickOutsideOnly ? undefined : scheduleMoreTooltipClose}
                    >
                      <MoreIcon/>
                    </IconWrapperSpecial2>
                  }
                >
                  <ProjectActionsTooltipContent
                    onMouseEnter={() => {
                      isPointerInsideMoreTooltipRef.current = true;
                      openMoreTooltip();
                    }}
                    onMouseLeave={() => {
                      isPointerInsideMoreTooltipRef.current = false;
                      if (!closeOnClickOutsideOnly) {
                        scheduleMoreTooltipClose();
                      }
                    }}
                  >
                    <ProjectTooltip
                    project={project}
                    identifier={project.projectId}
                    isCopyLink={true}
                    isEditable={isEditable}
                    isCanBeDraft={isCanBeDraft}
                    canModerSendToCompetition={canSendToVScompetition}
                    canTransfer={!hideTransferProject}
                    competitionList={competitionList}
                    // isProjectAITranslateRemovable={isProjectAITranslateRemovable}
                    isReportable={profile && !isMe}
                    isInOnDisplay={isProjectOnDisplay}
                    isPartInCompetition={isProjectPartInCompetition}
                    isLongreadAndTeamOwner={isLongreadAndTeamOwner}
                    canEditFolders={canEditFolders}
                    onReport={handleReport}
                    onExport={onExport}
                    onTransfer={onTransfer}
                    onAttachProducts={handleAttachProducts}
                    onMoveDrafts={handleMoveToDrafts}
                    onMakeBilingual={handleMakeBilingual}
                    onSendToCompetition={handleSendToCompetition}
                    canMakeBilingual={canMakeBilingual}
                    isCoauthor={isCoAuthor}
                    onRejectCoauthor={handleRejectCoauthor}
                      //@ts-ignore
                    isTagModerator={isTagModerator}
                    isSuperModer={isSuperModer || canEditAllPrj || hasLmsAdminPolicy}
                    isCanVisibleCompetitionList={isCanVisibleCompetitionList}
                    canSendGift={isCanSendGift}
                    canViewStatistic={canGetStatisticForProject}
                    shouldDisplayShowcases={shouldDisplayTools}
                    isCollectionVote={isCollectionVote}
                    toggleTooltip={handleNestedDropdownOpenChange}
                    portalNestedDropdowns
                    closeOnClickOutsideOnly={closeOnClickOutsideOnly}
                    onShouldReload={onShouldReload}
                    />
                  </ProjectActionsTooltipContent>
                </ Tooltip>
              )}
            </ToolBarItemWrapper>
          )}
          <>
            {shouldShowRepostButton && <ToolBarItemWrapper className="BookmarkButtonWrapper ps-action-btn">
              <RepostButton
                project={project}
                inActiveState={inActiveState}
              />
            </ToolBarItemWrapper>}
            {!isCollectionVote && !isFtbl && <ToolBarItemWrapper className="BookmarkButtonWrapper ps-action-btn">
              <BookmarkButton
                project={project}
                entityType={'project'}
                entityId={project.book ? project.book.bookId : project.projectId}
                inActiveState={inActiveState}
              />
            </ToolBarItemWrapper>}
            
            <ToolBarItemWrapper className="ShareButtonWrapper ps-action-btn">
              <IconWrapperSpecial2 onClick={inActiveState ? () => false : () => modal.show('share', {
                isBook: project?.isBook,
                project: project,
                projectId: project?.projectId,
                childEntities: childEntities,
                projectStatus: project?.status,
                setChildEntities: childEntities,
                isPresentation,
                onPrint: printPdfCard,
                title: project?.title,
                images: project?.titleImages,
              })}>
                <HintTooltip text={t(isCollectionVote ? "sharing.title_voting" : "hints.share")} z={8} {...hintProps}
                             noDisappearDelay={isBottomTooltip} positionY={is744 ? "bottom" : "default"}
                             customStyle={isCollectionVote ? superPuperStyles : isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)}
                             isPermanent={isCollectionVote && !isBottomTooltip} onWhiteBg={onWhiteBg}>
                  <ShareIcon/>
                </HintTooltip>
              </IconWrapperSpecial2>
            </ToolBarItemWrapper>

            {(isCreator || isModer) && !isCollectionVote && <ToolBarItemWrapper className="CreateProductButtonWrapper ps-action-btn">
                <IconWrapperSpecial2 
                  onClick={inActiveState ? () => false : () => createProductByProject(project.projectId)}
                  >
                  <HintTooltip text={t("hints.create_product")} z={8} {...hintProps}
                    noDisappearDelay={isBottomTooltip} positionY={is744 ? "bottom" : "default"}
                    isPermanent={isCollectionVote && !isBottomTooltip} onWhiteBg={onWhiteBg}>
                  <AddProductIcon />
                  </HintTooltip>
                </IconWrapperSpecial2>
              </ToolBarItemWrapper>} 
              
            {isCollectionVote && (
              <ProjectRatingsButton isBottomTooltip={isBottomTooltip} onWhiteBg={onWhiteBg}
                                    projectId={project?.projectId} tooltipProps={hintProps}/>
            )}
          </>
          <ToolBarItemWrapper className="LikesButtonWrapper ps-action-btn">
            <LikesController
              entityId={project.projectId}
              entityType="project"
              inActiveState={inActiveState}
              tooltipProps={hintProps}
            />
          </ToolBarItemWrapper>

          <ViewCount
              entityId={project.projectId}
              entityType="project"
              disabled={isBottomTooltip && !is743}
            />

        </ButtonsWrapper>
      </FlexBox>
    )
  }

  return (
    <>
      <FlexBox align="stretch">
        <ButtonsWrapper
          justify="flex-start"
          direction={buttonsWrapperDirection}
          directionMobile="row"
          justifyMobile="center"
          className="buttons-wrapper"
          alignMobile={orientation === 'vertical' ? 'center' : 'flex-start'}
          align="center"
          canEditFolders={canEditFolders}
          inActiveState={inActiveState}
          isProjectPage={isProjectPage}
          isPresentationTooltip={isPresentationTooltip}
          isPresentation={isPresentation}
          isProjectButtons={isProjectButtons}
        >
          {(isCreator || isModer) && !isCollectionVote && !isBottomTooltip && is743 && 
          <ToolBarItemWrapper isBottomTooltip={isBottomTooltip} className="CreateProductButtonWrapper ps-action-btn">
            <IconWrapperSpecial2 
              onClick={inActiveState ? () => false : () => createProductByProject(project.projectId)}
              >
              <HintTooltip text={t("hints.create_product")} z={8} {...hintProps}
                noDisappearDelay={isBottomTooltip} positionY={is744 ? "bottom" : "default"}
                isPermanent={isCollectionVote && !isBottomTooltip} onWhiteBg={onWhiteBg}>
              <AddProductIcon />
              </HintTooltip>
            </IconWrapperSpecial2>
          </ToolBarItemWrapper>} 

          {!!profile && (
            <ToolBarItemWrapper className="MoreButtonWrapper ps-action-btn" isBottomTooltip={isBottomTooltip}>
              {isProjectButtonHidden ? null : inActiveState ? (
                <IconWrapperSpecial2>
                  <MoreIcon/>
                </IconWrapperSpecial2>
              ) : (
                <Tooltip
                  className="project-actions-tooltip"
                  visible={isMoreTooltipOpen}
                  onClickOutside={handleMoreTooltipClickOutside}
                  target={
                    <IconWrapperSpecial2
                      onClick={openMoreTooltip}
                      onMouseEnter={openMoreTooltip}
                      onMouseLeave={closeOnClickOutsideOnly ? undefined : scheduleMoreTooltipClose}
                    >
                      <MoreIcon/>
                    </IconWrapperSpecial2>
                  }
                >
                  <ProjectActionsTooltipContent
                    onMouseEnter={() => {
                      isPointerInsideMoreTooltipRef.current = true;
                      openMoreTooltip();
                    }}
                    onMouseLeave={() => {
                      isPointerInsideMoreTooltipRef.current = false;
                      if (!closeOnClickOutsideOnly) {
                        scheduleMoreTooltipClose();
                      }
                    }}
                  >
                    <ProjectTooltip
                    project={project}
                    identifier={project.projectId}
                    isCopyLink={true}
                    isEditable={isEditable}
                    isCanBeDraft={isCanBeDraft}
                    canEditFolders={canEditFolders}
                    canModerSendToCompetition={canSendToVScompetition}
                    competitionList={competitionList}
                    isLongreadAndTeamOwner={isLongreadAndTeamOwner}
                    isReportable={profile && !isMe}
                    isInOnDisplay={isProjectOnDisplay}
                    orientationType={ORIENTATION_TYPE.project}
                    isPartInCompetition={isProjectPartInCompetition}
                    //repostTools={repostTools}
                    // onRepostRemove={onRepostRemove}
                    onDeleteAITranslation={
                      (id: string) => {
                        const confirmation = window.confirm(t('project.confirmation_msg.delete_translation'))
                        if (confirmation) {
                          API.fetch(
                            `${Endpoints.geograffee}/api/Project/RevertAutoTranslation?projectId=${id}`,
                            {
                              method: 'GET',
                            },
                          ).then(res => window.location.reload())
                        }                        
                      }
                    }
                    onReport={handleReport}
                    canTransfer={!hideTransferProject}
                    onExport={onExport}
                    onTransfer={onTransfer}
                    onAttachProducts={handleAttachProducts}
                    onMoveDrafts={handleMoveToDrafts}
                    onMakeBilingual={handleMakeBilingual}
                    onProtect={(projectId) => {
                      const isBook = project?.isBook;
                      const action = !!(project as any)?.isProtected? 'disabled' : 'enabled';

                      const isCantBeDisabled = (project as any)?.protectedStatus === protectProcessStatuses.InProcess;

                      if (isCantBeDisabled) {
                        // toasts.error(t('toasts.can_be_disabled_protect'));
                        return;
                      }

                      //@ts-ignore
                      const confirmation = window.confirm(t(!!project?.isProtected ? 'toasts.user_wont_unprotect' : 'toasts.user_wont_protect'));
                      
                      if (confirmation) {
                        const book = isBook && !isChapter;
                        API.request()
                          .endpoint(Endpoints.geograffee)
                          .url(`/api/${book ? 'Book' : 'Project'}/Protect`)
                          .post()
                          .body({
                            projectId,
                            action: protectStatuses[action]
                          })
                          .send()
                          .then((r) => {
                            if (r?.status === 403) {                              
                              toasts.error(t('project_edit.frames.permissions_protect'));
                              return;
                            }
                            window.location.reload();
                          });
                      }
                    }}
                    onSendToCompetition={handleSendToCompetition}
                    isCoauthor={isCoAuthor}
                    onRejectCoauthor={handleRejectCoauthor}
                    canMakeBilingual={canMakeBilingual}
                    isTagModerator={isTagModerator}
                    isSuperModer={isSuperModer || canEditAllPrj || hasLmsAdminPolicy}
                    //  isCanVisibleCompetitionList={isCanVisibleCompetitionList}
                    shouldVisibleProtectButton={shouldVisibleProtectButton}
                    canSendGift={isCanSendGift}
                    onShowOriginals={isModer || canEditAllPrj || hasLmsAdminPolicy || canViewOrigImagesPrj ? () => {
                      dispatch(CurrentProjectActions.setOriginalsState({ value: true }))
                      toasts.info('Показаны оригиналы изображений')
                    } : undefined}                    
                    canViewStatistic={canGetStatisticForProject}
                    shouldDisplayShowcases={shouldDisplayTools}
                    isCollectionVote={isCollectionVote}
                    toggleTooltip={handleNestedDropdownOpenChange}
                    portalNestedDropdowns
                    closeOnClickOutsideOnly={closeOnClickOutsideOnly}
                    onShouldReload={onShouldReload}
                    />
                  </ProjectActionsTooltipContent>
                </Tooltip>
              )}
            </ToolBarItemWrapper>
          )}

          {(isBottomTooltip || !isMobile) && (
            <>
              {shouldShowRepostButton && <ToolBarItemWrapper className="BookmarkButtonWrapper ps-action-btn">
                 <RepostButton
                    isFill
                    project={project}
                    inActiveState={inActiveState}
                  />
              </ToolBarItemWrapper>}
              {!isSuperPuperProject && !isFtbl && <ToolBarItemWrapper className="BookmarkButtonWrapper ps-action-btn">
                <HintTooltip customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} text={t("hints.bookmark")} z={9} noDisappearDelay={isBottomTooltip} onWhiteBg={onWhiteBg} {...hintProps}>

                  <BookmarkButton
                    project={project}
                    entityType={'project'}
                    entityId={project.book ? project.book.bookId : project.projectId}
                    inActiveState={inActiveState}
                  />
                </HintTooltip>
              </ToolBarItemWrapper>}
              <ToolBarItemWrapper className="ShareButtonWrapper ps-action-btn">
                <IconWrapperSpecial2 onClick={inActiveState ? () => false : () => modal.show('share', {
                  isBook: project?.isBook,
                  project: project,
                  projectId: project?.projectId,
                  childEntities: childEntities,
                  projectStatus: project?.status,
                  setChildEntities: setChildEntities,
                  isPresentation,
                  onPrint: printPdfCard,
                  title: project?.title,
                  images: project?.titleImages,
                  cardId: project?.cardId,
                })}>
                   <HintTooltip customStyle={isCollectionVote ? superPuperStyles : isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} text={t(isCollectionVote ? "sharing.title_voting" : "hints.share")} z={8}
                               noDisappearDelay={isBottomTooltip} positionY={is744 ? "bottom" : "default"}
                               isPermanent={isCollectionVote && !isBottomTooltip} onWhiteBg={onWhiteBg} {...hintProps}>
                    <ShareIcon/>
                  </HintTooltip>
                </IconWrapperSpecial2>
              </ToolBarItemWrapper>
              {(isCreator || isModer) && !isCollectionVote && <ToolBarItemWrapper isBottomTooltip={isBottomTooltip} className="CreateProductButtonWrapper ps-action-btn">
                <IconWrapperSpecial2 
                  onClick={inActiveState ? () => false : () => createProductByProject(project.projectId)}
                  >
                  <HintTooltip text={t("hints.create_product")} z={8} {...hintProps}
                    noDisappearDelay={isBottomTooltip} positionY={is744 ? "bottom" : "default"}
                    isPermanent={isCollectionVote && !isBottomTooltip} onWhiteBg={onWhiteBg}>
                  <AddProductIcon />
                  </HintTooltip>
                </IconWrapperSpecial2>
              </ToolBarItemWrapper>} 
              {isLMSProject && isStudent && <ToolBarItemWrapper className="LMSGradeButtonWrapper ps-action-btn">
                <IconWrapperSpecial2 
                  onClick={inActiveState ? () => false : () => modal.show('formula', { moduleId: lmsModuleInfo?.moduleProjectId, expressionName: expressionName, isStudentView: true })}
                  >
                  <HintTooltip text={t("hints.lms_grade")} z={8} {...hintProps}
                    noDisappearDelay={isBottomTooltip} positionY={is744 ? "bottom" : "default"}
                    onWhiteBg={onWhiteBg}>
                  <LMSGradeIcon />
                  </HintTooltip>
                </IconWrapperSpecial2>
              </ToolBarItemWrapper>}
              {isCollectionVote && (
                <ProjectRatingsButton isBottomTooltip={isBottomTooltip} onWhiteBg={onWhiteBg}
                                      projectId={project?.projectId} tooltipProps={hintProps} />
              )}
            </>
          )}
          {(isBottomTooltip || (!isMobile && !isOnlines)) && (
            <ToolBarItemWrapper className="LikesButtonWrapper ps-action-btn">
              <LikesController
                entityId={project.projectId}
                entityType="project"
                inActiveState={inActiveState}
                tooltipProps={hintProps}
              />
            </ToolBarItemWrapper>
          )}

          {(isBottomTooltip || !isMobile) && (
              <ViewCount
                entityId={project.projectId}
                entityType="project"
                disabled={isBottomTooltip && !is743}
                toolTipProps={hintProps}
              />
          )}

        </ButtonsWrapper>
      </FlexBox>
    </>
  );
}

export default memo(ProjectButtons);